const regex = {
  name: /^[a-zA-Z\s]{0,100}$/,
  name_length: /^.{0,100}$/,
  email: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
  email_length: /^.{0,254}$/,
  phoneUS: /^(\d{10})$|^(\d{3}-\d{3}-\d{4})$/,
  state: /^(AL|AK|AZ|AR|CA|CO|CT|DE|DC|FL|GA|HI|ID|IL|IN|IA|KS|KY|LA|ME|MD|MA|MI|MN|MS|MO|MT|NE|NV|NH|NJ|NM|NY|NC|ND|OH|OK|OR|PA|PR|RI|SC|SD|TN|TX|UT|VT|VA|WA|WV|WI|WY)$/i,
  zip: /^\d{5}$/,
  npi: /^\d{10}$/,
  password: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/,
  url: /^(https?:\/\/)?(www\.)?[-a-zA-Z0-9@:%._+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_+.~#?&//=]*)$/
};

module.exports = {
  form_surgeon_selector: {
    rules: [
      {
        name: "required",
        fields: [
          "firstName", 
          "lastName", 
          "email", 
          "npiNumber", 
          "password", 
          "confirmPassword",
          "credentials",
          "ageOfPatients",
          "specialties",
          "facilitySearch", 
          "address", 
          "city", 
          "state", 
          "zipCode", 
          "phoneNumber", 
          "procedures",
          "receiveUpdates",
          "agreeToTerms",
          "agreeToSubmission"
        ],
        required: true,
        messages: {
          firstName: "Please enter your first name.",
          lastName: "Please enter your last name.",
          email: "Please enter your email address.",
          npiNumber: "Please enter your NPI number.",
          password: "Please enter a password.",
          confirmPassword: "Please confirm your password.",
          credentials: "Please select at least one credential.",
          ageOfPatients: "Please select at least one age group.",
          specialties: "Please select at least one specialty.",
          facilitySearch: "Please enter a facility name.",
          address: "Street address is required.",
          city: "City is required.",
          state: "State is required.",
          zipCode: "Zip code is required.",
          phoneNumber: "Phone number is required.",
          procedures: "Please select at least one procedure.",
          receiveUpdates: "You must agree to receive updates.",
          agreeToTerms: "You must agree to the terms and conditions.",
          agreeToSubmission: "You must agree to submit your information."
        }
      },
      {
        name: "name format validation",
        fields: ["firstName", "middleName", "lastName"],
        validators: [regex.name],
        messages: {
          firstName: "Please enter a valid first name.",
          middleName: "Please enter a valid middle name.",
          lastName: "Please enter a valid last name."
        }
      },
      {
        name: "email format validation",
        fields: ["email"],
        validators: [regex.email],
        messages: {
          email: "Please enter a valid email address."
        }
      },
      {
        name: "phone format validation",
        fields: ["phoneNumber"],
        validators: [regex.phoneUS],
        messages: {
          phoneNumber: "Please enter a valid phone number."
        }
      },
      {
        name: "state validation",
        fields: ["state"],
        validators: [regex.state],
        messages: {
          state: "Please select a valid state."
        }
      },
      {
        name: "zip format validation",
        fields: ["zipCode"],
        validators: [regex.zip],
        messages: {
          zipCode: "Please enter a valid zip code (5 digits)."
        }
      },
      {
        name: "npi format validation",
        fields: ["npiNumber"],
        validators: [regex.npi],
        messages: {
          npiNumber: "Please enter a valid NPI number (10 digits)."
        }
      },
      {
        name: "password format validation",
        fields: ["password"],
        validators: [regex.password],
        messages: {
          password: "Password must contain at least 8 characters, including uppercase, lowercase, number and special character."
        }
      },
      {
        name: "password match validation",
        fields: ["confirmPassword"],
        custom: true,
        validate: (value, formValues) => {
          return value === formValues.password || "Passwords do not match.";
        },
        messages: {
          confirmPassword: "Passwords do not match."
        }
      },
      {
        name: "facility website validation",
        fields: ["facilityWebAddress"],
        validators: [regex.url],
        messages: {
          facilityWebAddress: "Please enter a valid website URL."
        }
      }
    ],
  },
}; 